import React, { FC, ReactNode } from 'react'
import { BottomSheet, ScreenContext, SidebarPopup } from 'react-components'

interface Props {
    isOpen: boolean
    onRequestClose: () => void
    children: ReactNode
    header?: ReactNode
    footer?: ReactNode
}

const ActionSheet: FC<Props> = ({ isOpen, onRequestClose, children, header, footer }) => {
    const { isMobile } = React.useContext(ScreenContext)
    return isMobile ? (
        <BottomSheet
            isOpen={isOpen}
            onClose={onRequestClose}
            rootElementSelector="#__next"
            maxHeightRatio={0.9}
            borderRadius="1.5rem"
            showSwipeIcon
            header={header}
            content={children}
            footer={footer}
            enableSwipeToClose={false}
        />
    ) : (
        <SidebarPopup
            isOpen={isOpen}
            onClose={onRequestClose}
            rootElementSelector="#__next"
            header={header}
            content={children}
            footer={footer}
            width={30}
            minWidth="410px"
        />
    )
}

export default ActionSheet
